import { default as dayjs } from 'dayjs';

import { translate as t } from './translate';

export const formatDate = (date: number) => dayjs(date).format('MMMM D, YYYY h:mm A');

export const formatSimpleDate = (date: string | Date) => dayjs(date).format('DD/MM/YYYY');

export const formatResponseToOptions = ({
  labelProp = 'name',
  valueProp = 'id',
  queryData,
}: {
  labelProp?: string;
  valueProp?: string;
  queryData?: any[];
}) => {
  if (queryData) {
    const options = queryData.map((item) => ({
      label: t(item[labelProp]),
      value: item[valueProp],
    }));

    return options;
  }

  return [];
};
